module.exports = __webpack_public_path__ + "img/apple_share_icon.21afabff.png";